import React from 'react';
import { Tab } from 'screens/booker/components/Tab';
import { LISTING_TYPE } from '../ScreenRequest';
import { routes } from 'routes';
import { css } from '@emotion/react';
import { Badge } from 'components/Badge';
import { useSearchParams } from 'react-router-dom';

export const ListingTabs = ({ listingType, requestCounts }: { listingType: string | null }) => {
	const [searchParams] = useSearchParams();

	return (
		<div
			css={css`
				display: flex;
				justify-content: space-between;
				width: 100%;
			`}
		>
			<div
				css={css`
					display: flex;
					gap: 24px;
					align-items: center;
				`}
			>
				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.SUBMITTED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.SUBMITTED || listingType === null}
				>
					Potvrzené
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.SUBMITTED && listingType !== null}
						primaryFill={listingType === LISTING_TYPE.SUBMITTED || listingType === null}
					>
						{!requestCounts.fetching ? requestCounts.data.requestCounts.confirmed : '-'}
					</Badge>
				</Tab>

				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.COMPLETED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.COMPLETED}
				>
					Kompletní
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.COMPLETED}
						primaryFill={listingType === LISTING_TYPE.COMPLETED}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.completed : '-'}
					</Badge>
				</Tab>

				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.INCOMPLETED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.INCOMPLETED}
				>
					Nekompletní
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.INCOMPLETED}
						primaryFill={listingType === LISTING_TYPE.INCOMPLETED}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.incompleted : '-'}
					</Badge>
				</Tab>

				<div
					css={css`
						padding: 12px 0;
						height: 100%;
						display: flex;
					`}
				>
					<div
						css={css`
							width: 1px;
							height: 20px;
							background: #e2e3e9;
						`}
					></div>
				</div>

				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.EXPORTED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.EXPORTED}
				>
					Exportované
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.EXPORTED}
						primaryFill={listingType === LISTING_TYPE.EXPORTED}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.exported : '-'}
					</Badge>
				</Tab>

				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.NOTEXPORTED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.NOTEXPORTED}
				>
					Neexportované
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.NOTEXPORTED}
						primaryFill={listingType === LISTING_TYPE.NOTEXPORTED}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.nonExported : '-'}
					</Badge>
				</Tab>

				<div
					css={css`
						padding: 12px 0;
						height: 100%;
						display: flex;
					`}
				>
					<div
						css={css`
							width: 1px;
							height: 20px;
							background: #e2e3e9;
						`}
					></div>
				</div>
				<Tab
					horizontal
					to={buildUrlWithParams(
						routes.booker.request,
						{ type: LISTING_TYPE.UNSUBMITTED },
						searchParams,
					)}
					active={listingType === LISTING_TYPE.UNSUBMITTED}
				>
					Nepotvrzené
					<Badge
						small
						grayFill={listingType !== LISTING_TYPE.UNSUBMITTED}
						primaryFill={listingType === LISTING_TYPE.UNSUBMITTED}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.nonConfirmed : '-'}
					</Badge>
				</Tab>
				<div
					css={css`
						padding: 12px 0;
						height: 100%;
						display: flex;
					`}
				>
					<div
						css={css`
							width: 1px;
							height: 20px;
							background: #e2e3e9;
						`}
					></div>
				</div>

				<Tab
					horizontal
					to={buildUrlWithParams(routes.booker.request, { type: LISTING_TYPE.PAST }, searchParams)}
					active={listingType === LISTING_TYPE.PAST}
				>
					Uplynulé
					<Badge
						small
						primaryFill={listingType === LISTING_TYPE.PAST}
						grayFill={
							!requestCounts.fetching &&
							requestCounts.data?.requestCounts?.past &&
							listingType === LISTING_TYPE.PAST
						}
					>
						{!requestCounts.fetching ? requestCounts.data?.requestCounts?.past : '-'}
					</Badge>
				</Tab>
			</div>
		</div>
	);
};

export function buildUrlWithParams(
	basePath: string,
	newParams: Record<string, string | null>,
	currentParams: URLSearchParams,
): string {
	const merged = new URLSearchParams(currentParams.toString());

	// Merge new params
	Object.entries(newParams).forEach(([key, value]) => {
		if (value === null) {
			merged.delete(key);
		} else {
			merged.set(key, value);
		}
	});

	return `${basePath}?${merged.toString()}`;
}
